<script lang="ts" setup>
import RangeInput from '@/components/RangeInput.vue';
import { faBed } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { useI18n } from 'vue-i18n';
import { useSearchFiltersStore } from '@/views/search/searchFiltersStore.ts';

const { t } = useI18n();

const filters = useSearchFiltersStore();

const minBedrooms = 0;
const maxBedrooms = 6;
const bedroomsStep = 1;
const bedroomsDistance = 0;
</script>

<template>
  <div>
    <div class="mb-2 flex w-full items-center justify-start">
      <FontAwesomeIcon :icon="faBed" class="mr-2 h-4 text-gray-500" />
      {{ t('views.search.bedrooms') }}
    </div>
    <RangeInput
      v-model:max="filters.bedroomsMax"
      v-model:min="filters.bedroomsMin"
      :range-distance="bedroomsDistance"
      :range-max="maxBedrooms"
      :range-min="minBedrooms"
      :range-step="bedroomsStep"
      :unlimited-label="true"
      :zero-label="t('views.search.studio-option')"
    />
  </div>
</template>

<style lang="css" scoped></style>
